"use client";

import React from "react";
import { Navbar } from "@/components/ui/navbar";
import { Footer } from "@/components/ui/footer";
import {
	ThemeBackground,
	ThemeCard,
	ThemeText,
	AuroraBlobs,
} from "@/components/ui/theme-utils";
import { useTheme } from "@/hooks/useTheme";
import { cn } from "@/lib/utils";

export default function RefundPolicyPage() {
	const { isDark } = useTheme();

	return (
		<ThemeBackground className="min-h-screen flex flex-col">
			<Navbar />

			<main className="flex-grow">
				<section className="relative overflow-hidden pt-40 sm:pt-48 pb-12 sm:pb-16">
					<div
						className={cn(
							"absolute inset-0 -z-10",
							isDark ? "bg-mesh-dark" : "bg-mesh-light"
						)}
					/>
					<div
						className={cn(
							"absolute inset-0 -z-10 opacity-40",
							"bg-grid"
						)}
					/>
					<AuroraBlobs variant="mixed" />

					<div className="container relative z-10 mx-auto px-5 sm:px-6">
						<div className="mx-auto max-w-4xl">
							<div className="text-center mb-8">
								<h1 className="responsive-heading-2">
									Cancellation & <span className="text-gradient">Refund</span> Policy
								</h1>
								<ThemeText variant="subtle" className="mt-6 text-lg sm:text-xl leading-relaxed">
									Last updated: 12-12-2025
								</ThemeText>
							</div>

							<ThemeCard className="p-6 sm:p-10">
								<div className="space-y-6">
									<ThemeText>
										NOVARISE believes in helping its customers as far as possible, and has therefore a liberal cancellation
										policy. Under this policy:
									</ThemeText>

									<ul className="list-disc pl-6 space-y-6 marker:text-brand-500">
										<li>
											<ThemeText>
												Cancellations will be considered only if the request is made immediately after placing the order.
												However, the cancellation request may not be entertained if the orders have been communicated to the
												vendors/merchants and they have initiated the process of shipping them.
											</ThemeText>
										</li>
										<li>
											<ThemeText>
												NOVARISE does not accept cancellation requests for perishable items like flowers, eatables etc.
												However, refund/replacement can be made if the customer establishes that the quality of product
												delivered is not good.
											</ThemeText>
										</li>
										<li>
											<ThemeText>
												In case of receipt of damaged or defective items please report the same to our Customer Service team.
												The request will, however, be entertained once the merchant has checked and determined the same at his
												own end. This should be reported within Only same day days of receipt of the products. In case you feel
												that the product received is not as shown on the site or as per your expectations, you must bring it to the
												notice of our customer service within Only same day days of receiving the product. The Customer
												Service Team after looking into your complaint will take an appropriate decision.
											</ThemeText>
										</li>
										<li>
											<ThemeText>
												In case of complaints regarding products that come with a warranty from manufacturers, please refer
												the issue to them. In case of any Refunds approved by the NOVARISE, it’ll take 16-30 Days days for the
												refund to be processed to the end customer.
											</ThemeText>
										</li>
									</ul>
								</div>
							</ThemeCard>
						</div>
					</div>
				</section>
			</main>

			<Footer isHomePage={false} />
		</ThemeBackground>
	);
}
